<style src="./SentinelOriana.scss" lang="scss"></style>
<template>
  <section class="sentinel-oriana">
    <section class="spot-map">
      <parking-list
        :parks="parkList"
        :sentinel="sentinelInfos"
        @selected-spots="selectSpot"
        @selected-sentinel="selectedSentinel"
        @refresh-sentinel="refreshSentinel"/>
    </section>

    <section class="monitor-preview">
      <spot-monitor
        :spots="sentinelSpotSelected" />
    </section>

  </section>
</template>

<script>
import { URI_ORIANA } from '@/config/config';
import ParkingList from './components/parking-list/parking-list.vue';
import SpotMonitor from './components/spot-monitor/spot-monitor.vue';

export default {
  components: {
    ParkingList,
    SpotMonitor,
  },
  data: () => ({
    parkList: [],
    spotsSelected: [], // Not used
    sentinelInfos: {},
    sentinelSpotSelected: [],
  }),
  mounted() {
    this.start();
  },
  methods: {
    refreshSentinel() {
      this.loadSentinel();
    },
    async start() {
      await this.ListParks();
      this.loadSentinel();
    },
     async ListParks() {
      try {
        const parkListRequest = await this.$store.dispatch('PARKING/GetParkList');
        const parkList = parkListRequest.map(park => ({
          parkId: park._id,
          parkName: park.parkName,
          disabled: park.disabled,
          collapsed: true,
          spots: park.spots.map(spot => ({
            spotId: spot._id,
            spotName: spot.name
          })),
        }));
        this.parkList = parkList;
      } catch (error) {
        this.$toasted.error('Não foi possível listar estacionarmentos');
      }
    },
    async loadSentinel() {
      const opts = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      };

      const sentinelInfosRaw = await fetch(
        `${URI_ORIANA}list-photos`,
        opts,
      );

      const sentinelInfos = await sentinelInfosRaw.json();
      this.sentinelInfos = sentinelInfos;
    },
    selectSpot(spots) {
      this.spotsSelected = spots;
    },
    selectedSentinel(sentinelSpot) {
      this.sentinelSpotSelected = sentinelSpot;
    }
  }
};
</script>
